import Component from '@glimmer/component';

import { on } from '@ember/modifier';
import { service } from '@ember/service';
import stopPropagation from 'ember-event-helpers/helpers/stop-propagation';

import TimeSeriesSelectionLineDefaultDate from 'rise-ui/components/time-series/selection/output/actions/date.gjs';
import fnx from 'rise-ui/helpers/fnx.js';
import qpDateRel from 'rise-ui/helpers/qp-date-rel.js';
import string from 'rise-ui/helpers/string.js';
import timeSeriesSelect from 'rise-ui/helpers/time-series-select.js';

export default class TimeSeriesSelectionLineDefaultDatesComponent extends Component {
  @service('time-series/dates') dates;

  <template>
    <div class="c-time-series-selection-line c-time-series-selection-line-default c-lined__line qa-default-dates"
      ...attributes
    >
      <div class="c-time-series-selection-line__wrapper">
        <span role="button"
          class="c-time-series-selection-line-actions c-time-series-selection-line-actions--default dummy-button"
          {{on "click" (stopPropagation)}}
        ></span>
        <span class="c-time-series-selection-line__dates">
          <TimeSeriesSelectionLineDefaultDate
            @layer={{@layer}}
            @copyOption={{false}}
            @linkToClear={{timeSeriesSelect clearDefaultDates=true}}
            @linkToWeek={{timeSeriesSelect setDefaultDates=(qpDateRel "week")}}
            @linkToMonth={{timeSeriesSelect setDefaultDates=(qpDateRel "month")}}
            @linkToYear={{timeSeriesSelect setDefaultDates=(qpDateRel "year")}}
            @linkTo10Years={{timeSeriesSelect setDefaultDates=(qpDateRel "decade")}}
            @linkToAll={{timeSeriesSelect setDefaultDates=(qpDateRel "all")}}
            @dateRanges={{this.dates.defaultDates}}
            @onDatesChange={{this.dates.onDefaultDateChange}}
            @onDatesCleared={{@onDatesCleared}}
            @onDropdownSelection={{fnx @onDateDropdownSelection}}
          />
        </span>
        <div class="c-time-series-selection-line__label c-time-series-selection-line-default__label">
          {{string "default-dates"}}:
        </div>
      </div>
    </div>
  </template>
}
